// src/BingoBoard.js
import React, { useState, useRef, useEffect } from 'react';
import html2canvas from 'html2canvas';

const BingoBoard = ({ onAddToBook }) => {
  // الكلمات الافتراضية (يمكنك تغييرها)
  const [words, setWords] = useState("LION, TIGER, BEAR, WOLF, FOX, DEER, COW, PIG, DUCK, HEN, BAT, ANT, BEE, OWL, RAT, FROG, SEAL, CRAB, WHALE, SHARK, CAT, DOG, FISH, BIRD, HORSE");
  const [grid, setGrid] = useState([]);
  const printRef = useRef();

  // دالة توليد الشبكة
  const generate = () => {
    // 1. تحويل النص إلى مصفوفة وتنظيف المسافات
    let arr = words.split(',').map(w => w.trim()).filter(w => w);
    
    // 2. التحقق من وجود 24 كلمة على الأقل
    if(arr.length < 24) {
      alert("Please enter at least 24 words to fill the card!");
      return;
    }

    // 3. خلط الكلمات عشوائياً (Shuffle)
    arr = arr.sort(() => 0.5 - Math.random()).slice(0, 24);

    // 4. إضافة خانة "مجاني" في الوسط (index 12)
    arr.splice(12, 0, "FREE");
    
    setGrid(arr);
  };

  // دالة الإضافة للكتاب
  const handleAddToBook = () => {
    if (printRef.current) {
      html2canvas(printRef.current).then((canvas) => {
        onAddToBook('Bingo Card', canvas.toDataURL('image/png'));
      });
    }
  };

  // توليد تلقائي عند فتح الصفحة
  useEffect(() => { generate(); }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
      <h2 style={{ color: '#2c3e50', fontFamily: 'sans-serif' }}>Bingo Card Generator 🎟️</h2>
      
      {/* لوحة التحكم */}
      <div style={{ 
        background: 'white', padding: '20px', borderRadius: '15px', 
        marginBottom: '20px', width: '100%', maxWidth: '600px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.05)'
      }}>
        <label style={{ fontWeight: 'bold', fontSize: '13px', color: '#636e72', marginBottom: '5px', display: 'block' }}>
          ENTER WORDS (Comma Separated):
        </label>
        <textarea 
          value={words} 
          onChange={(e) => setWords(e.target.value)} 
          style={{ width: '100%', height: '80px', padding: '10px', borderRadius: '8px', border: '1px solid #dfe6e9', fontFamily: 'inherit' }}
        />
        
        <div style={{ marginTop: '15px', display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button onClick={generate} style={btnStyle('#6c5ce7')}>🔄 Shuffle & Generate</button>
          <button onClick={handleAddToBook} style={btnStyle('#e67e22')}>📖 Add to Book</button>
        </div>
      </div>

      {/* بطاقة البينغو (للطباعة) */}
      <div ref={printRef} style={{ 
        background: 'white', padding: '30px', borderRadius: '10px', 
        border: '1px solid #eee', width: '450px', maxWidth: '100%'
      }}>
        
        {/* عنوان البطاقة */}
        <h1 style={{ 
          textAlign: 'center', fontSize: '50px', margin: '0 0 20px 0', 
          letterSpacing: '25px', color: '#2d3436', fontWeight: '900',
          textIndent: '25px' // لتوسيط الحروف مع المسافات
        }}>
          BINGO
        </h1>

        {/* الشبكة 5x5 */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(5, 1fr)', 
          gap: '2px', 
          background: '#2d3436', 
          border: '4px solid #2d3436' 
        }}>
          {grid.map((word, i) => (
            <div key={i} style={{ 
              background: i === 12 ? '#ffeaa7' : 'white', // الوسط لونه مختلف
              aspectRatio: '1/1', // مربع مثالي
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              textAlign: 'center',
              padding: '5px',
              fontSize: '12px',
              fontWeight: 'bold',
              color: '#2d3436',
              wordBreak: 'break-word'
            }}>
              {word}
            </div>
          ))}
        </div>
        
        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '12px', color: '#b2bec3' }}>
          Generated by PuzzlePlay
        </div>
      </div>
    </div>
  );
};

// ستايل الأزرار
const btnStyle = (bg) => ({ 
  background: bg, color: 'white', border: 'none', padding: '10px 20px', 
  borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' 
});

export default BingoBoard;